import React from 'react';
import {useSelector} from 'react-redux';

function Progress(props) {

    const sections = useSelector(state => state.preCruise.sections);

    // Using explicit mappings so Tailwind sees the concrete class names to generate css
    const gridColsMap = {
        1: 'grid-cols-1',
        2: 'grid-cols-2',
        3: 'grid-cols-3',
        4: 'grid-cols-4',
        5: 'grid-cols-5',
        6: 'grid-cols-6',
    };

    const progressGridColsMap = {
        2: 'grid-cols-progress-2',
        3: 'grid-cols-progress-3',
        4: 'grid-cols-progress-4',
        5: 'grid-cols-progress-5',
        6: 'grid-cols-progress-6',
    };

    const count = sections.length;
    const colsClass = gridColsMap[count] || 'grid-cols-3';
    const progressClass = progressGridColsMap[count] || 'grid-cols-progress-3';

    return (
        <div>
            <div className="relative">
                {/* lines between steps */}
                <div className={`h-1 w-full absolute top-0 grid z-0 mt-2 ${progressClass}`}>
                    <div></div>
                    {[...Array(sections.length - 1)].map((_, index) =>
                        <div key={index} className={`border-primary-dark border-b-2 ${props.activeSection > index ? "border-solid" : "border-dotted"}`}></div>
                    )}
                    <div></div>
                </div>

                <div className={`grid text-center relative text-primary-dark ${colsClass}`}>
                    {sections.map((section, index) =>
                            <div key={index}>
                                <div className={`w-6 h-6 rounded-full border border-primary-dark inline-flex items-center justify-center text-sm font-bold ${index > props.activeSection ? "bg-white": "bg-primary-dark text-white"}`}>
                                    <span className="leading-none mb-2px">
                                    {index + 1}
                                    </span>
                                </div>
                                <div className={`mt-1 text-sm md:text-normal ${props.activeSection === index ? "font-bold" : ""}`}>
                                    {section.label}
                                </div>
                            </div>)}
                </div>
            </div>
        </div>
    )
}

export default Progress;